<template>
  <div class="readonly props-group">
    <el-form-item label="只读">
      <el-checkbox v-model="component.properties.readonly"></el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-readonly',
  props: ['component'],
  watch: {
    'component.properties.required' (val) {
      if (val) {
        this.component.properties.readonly = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/readonly.vue